import configService from './app-config.service';

const getCurrentUser = async (authToken) => {
    const headers = new Headers();
    headers.append('Authorization', `Bearer ${authToken}`);

    const impersonatedUser = sessionStorage.getItem('impersonatedUser');
    if (impersonatedUser) {
        headers.append('ImpersonateUser', impersonatedUser);
    }

    const options = {
        method: 'GET',
        headers: headers
    };

    const response = await fetch(`${configService.appConfig.apiUrl}/User/Currentuser`, options);

    if (!response.ok) {
        const message = `An error occurred: ${response.statusText}`;
        console.error(message);
        return;
    }

    const jsonData = await response.json();
    return jsonData;
};

export default {
    getCurrentUser
};
